import React from 'react';

interface Props {
  width?: number;
  height?: number;
  fill?: string | number;
}

function TusdIcon({
  width = 50,
  height = 50,
  ...props
}: Props & React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 30 30" width={width} height={height} {...props}>
      <path
        opacity={0.2}
        d="M29.92 15c0 8.24-6.68 14.921-14.92 14.921-8.242 0-14.922-6.68-14.922-14.92C.078 6.76 6.758.078 15 .078 23.24.08 29.92 6.76 29.92 15z"
        fill="#B8C5D3"
      />
      <path
        d="M15 27C8.4 27 3 21.6 3 15S8.4 3 15 3s12 5.4 12 12-5.4 12-12 12z"
        fill="#002868"
      />
      <path
        d="M21.049 22.2H8.953A1.155 1.155 0 017.8 21.048V8.952c0-.634.518-1.152 1.152-1.152h12.096c.633 0 1.152.518 1.152 1.152v12.096c0 .634-.519 1.152-1.152 1.152z"
        fill="#fff"
      />
      <g fill="#002868">
        <path d="M10.611 20.75c-.037 0-.068-.034-.068-.072v-1.935c0-.038-.03-.072-.069-.072h-.683c-.038 0-.072-.031-.072-.07v-.373c0-.038.034-.073.072-.073h2.103c.037 0 .072.035.072.073v.374c0 .038-.034.069-.072.069h-.68a.075.075 0 00-.072.072v1.935c0 .038-.03.072-.069.072h-.462zM14.066 18.228c0-.038.03-.073.068-.073h.458c.038 0 .073.035.073.073v1.32c0 .783-.443 1.237-1.145 1.237-.698 0-1.137-.454-1.137-1.236v-1.321c0-.038.03-.073.069-.073h.457c.038 0 .073.035.073.073v1.34c0 .385.198.66.542.66.344 0 .542-.275.542-.66v-1.34zM16.766 19.003c-.06 0-.08-.023-.103-.069-.08-.187-.256-.305-.523-.305-.24 0-.442.084-.442.244 0 .176.187.248.599.298.626.072.984.263.984.76 0 .556-.488.85-1.114.85-.542 0-1.007-.263-1.08-.816-.008-.054.02-.073.073-.073h.42c.053 0 .084.023.1.065.056.183.251.325.533.325.248 0 .466-.092.466-.287 0-.232-.229-.274-.687-.332-.527-.068-.893-.221-.893-.706s.416-.832 1.069-.832c.587 0 .996.317 1.08.79.011.054-.004.088-.061.088h-.42zM17.8 20.75c-.039 0-.07-.034-.07-.072v-2.45c0-.038.031-.073.07-.073h1.037c.77 0 1.37.53 1.37 1.306 0 .763-.592 1.29-1.37 1.29h-1.038zm1.037-.515c.416 0 .74-.328.74-.782 0-.455-.325-.783-.744-.783h-.431c-.038 0-.069.034-.069.073v1.423c0 .038.031.068.069.068h.435z" />
      </g>
      <path
        d="M21.816 16.728H8.184a.193.193 0 01-.192-.192V8.952c0-.528.432-.96.96-.96h12.096c.528 0 .96.432.96.96v7.584a.193.193 0 01-.192.192z"
        fill="#002868"
      />
      <path
        d="M15.708 15.17H14.46a.144.144 0 01-.144-.143v-5.28c0-.08.065-.144.144-.144h1.248c.08 0 .144.065.144.144v5.28c0 .08-.064.144-.144.144z"
        fill="#fff"
      />
      <path
        d="M17.831 11.139h-5.664a.144.144 0 01-.144-.144V9.747c0-.08.065-.144.144-.144h5.664c.08 0 .144.065.144.144v1.248c0 .08-.064.144-.144.144z"
        fill="#fff"
      />
    </svg>
  );
}

const MemoTusdIcon = React.memo(TusdIcon);
export default MemoTusdIcon;
